module.exports = __webpack_public_path__ + "img/logo-visa.fda26884.png";